import type { CommercialAddressProvenance } from "../../../shared/commercial/location";
export type SupplyLocationSeed = { address: string; choices: string[]; ambiguous: boolean };

/** Seed the work-site field only when the supply data identifies one location. */
export function commercialSupplyLocationSeed(parties: Record<string, any> | null | undefined): SupplyLocationSeed {
  const supplyAddresses = (Array.isArray(parties?.supplies) ? parties.supplies : [])
    .map((supply: any) => String(supply?.address ?? "").trim())
    .filter(Boolean);
  const choices = Array.from(new Set(supplyAddresses));
  if (choices.length === 1) return { address: choices[0], choices, ambiguous: false };
  if (choices.length > 1) return { address: "", choices, ambiguous: true };
  const legacy = String(parties?.supplyAddress ?? "").trim();
  return { address: legacy, choices: legacy ? [legacy] : [], ambiguous: false };
}

export type CommercialAddressDetails = {
  street?: string;
  streetNumber?: string;
  complement?: string;
  postalCode?: string;
  municipality?: string;
  province?: string;
  autonomousCommunity?: string;
  country?: string;
  countryCode?: string;
  reference?: string;
  precision?: string;
  provenance?: CommercialAddressProvenance;
};

/** Postal addresses are only installation proposals after an explicit yes/no decision. */
export function commercialPostalLocationProposal(location: Record<string, unknown> | null | undefined, parties: Record<string, any> | null | undefined) {
  const supply = commercialSupplyLocationSeed(parties);
  const postalAddress = String(location?.billAddress ?? "").trim();
  return {
    supply,
    postalAddress,
    requiresPostalDecision: !supply.address && !supply.ambiguous && Boolean(postalAddress),
  };
}

/** Initial scale from an explicit provider precision type; never parsed from address text. */
export function commercialLocationZoom(precision: string | null | undefined): number {
  switch (String(precision ?? "").toLowerCase()) {
    case "portal":
    case "rooftop": return 19;
    case "street":
    case "range_interpolated": return 18;
    case "geometric_center": return 16;
    case "municipality": return 14;
    case "approximate": return 13;
    default: return 18;
  }
}
